import React, { Component } from "react";
import { Form, DatePicker } from 'antd';
import moment from "moment";
const {
  RangePicker
} = DatePicker;
export default class DateTimeContainer extends Component {
  disabledDate = current => {
    return current < moment('1900-01-01') || current > moment('2101-01-01');
  };

  render() {
    const {
      data,
      index
    } = this.props;
    const {
      getFieldDecorator
    } = this.props.form;
    const defaultArr = data.value ? data.value.split(",") : [];
    const defaultValue = defaultArr.length ? [moment(defaultArr[0], "YYYY-MM-DD HH:mm:ss"), moment(defaultArr[1], "YYYY-MM-DD HH:mm:ss")] : null;
    const conDateTimeRange = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || [];

          if (data.required && !val.length) {
            callback('必填项，请输入相关信息');
            return;
          }

          callback();
        }
      }],
      initialValue: defaultValue
    })(<RangePicker data-inspector-line="31" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\DateTimeRangeContainer\\index.jsx" disabled={data.frontUpdateFlag === 1} disabledDate={this.disabledDate} getCalendarContainer={triggerNode => triggerNode.parentNode} showTime />);
    return <div data-inspector-line="39" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\DateTimeRangeContainer\\index.jsx" className="detail-sel-dateTimeRange detail-sel-wrap">
        <Form.Item data-inspector-line="40" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\DateTimeRangeContainer\\index.jsx">
          {conDateTimeRange}
        </Form.Item>
      </div>;
  }

}